import React, { useState, createContext, useContext, useCallback } from "react";

const SidebarContext = createContext();
const SidebarActionsContext = createContext();

export const useSidebarContext = () => useContext(SidebarContext);
export const useSidebarActionsContext = () => useContext(SidebarActionsContext);

export function SidebarManagementContextProvider({ children }) {
  const [showSidebar, setShowSidebar] = useState(true);
  const [sidebarContentIsSetting, setSidebarContentIsSetting] =
    useState("dashboard");
  const [selectedSideBarPlant, setSelectedSideBarPlant] = useState(null);

  const updateSelSideBarPlant = useCallback((_value) => {
    setSelectedSideBarPlant(_value);
  }, []);

  const handleContentChange = (_value) => {
    setSidebarContentIsSetting(_value);
    // if (_value !== sidebarContentIsSetting) {
    //   setSidebarContentIsSetting((prev) => !prev);
    // }
  };
  return (
    <SidebarContext.Provider
      value={{ showSidebar, sidebarContentIsSetting, selectedSideBarPlant }}
    >
      <SidebarActionsContext.Provider
        value={{ setShowSidebar, handleContentChange, updateSelSideBarPlant }}
      >
        {children}
      </SidebarActionsContext.Provider>
    </SidebarContext.Provider>
  );
}
